/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */
import './styles.scss';
import { Badge } from 'reactstrap';
import { isNaOrNr, isNr } from '@utils/universalTrackerValue';
import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';
import { UniversalTrackerValuePlain } from '@g17eco/types/universalTrackerValue';

interface Props {
  utrv: Pick<UniversalTrackerValuePlain, 'status' | 'value' | 'valueData'>;
  showExplanation?: boolean;
  className?: string;
}

const notReportingText = 'Enter an answer to start reporting';
const notApplicableText = 'Enter an answer to make applicable';

export const NotApplicableBadge = ({ utrv, showExplanation = true, className = '' }: Props) => {
  const isNaNr = isNaOrNr(utrv);
  if (!isNaNr) {
    return null;
  }

  const isNotReporting = isNr(utrv);
  return (
    <div className={`badge__wrapper d-inline-block na-nr-info ${className}`}>
      <SimpleTooltip text={isNotReporting ? notReportingText : notApplicableText}>
        <Badge className='na-nr-info-top px-3 py-1' pill>
          {isNotReporting ? 'Not reporting' : 'Not applicable'}
        </Badge>
      </SimpleTooltip>
      {showExplanation ? (
        <div className='na-nr-info-bottom text-center'>
          {isNotReporting ? notReportingText : notApplicableText}
        </div>
      ) : null}
    </div>
  );
};
